export default function BeforeH5(props: any) {
    return (
        <svg width="62" height="176" viewBox="0 0 62 176" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M49.5951 26.8733L44.617 6.33568C44.4213 5.52794 43.4835 5.15901 42.7898 5.61681L31.0628 13.3563C30.3742 13.8108 30.339 14.8086 30.994 15.3104L47.699 28.1085C48.5973 28.7967 49.8616 27.973 49.5951 26.8733Z"
                fill="url(#paint0_linear_950_5895)"
                stroke="url(#paint1_linear_950_5895)"
                strokeWidth="0.4"
            />
            <path
                d="M5.31007 142.037C4.94094 141.961 4.55719 142.062 4.27391 142.311L-11.4928 156.158C-11.7487 156.383 -11.897 156.706 -11.9008 157.046L-11.974 163.591C-11.9805 164.174 -11.5673 164.677 -10.9943 164.784L-4.52252 165.993C-4.16036 166.06 -3.7872 165.958 -3.51038 165.715L12.2616 151.863C12.5205 151.635 12.6691 151.308 12.6697 150.963L12.6807 144.548C12.6817 143.979 12.2825 143.487 11.725 143.371L5.31007 142.037Z"
                fill="url(#paint2_linear_950_5895)"
                stroke="url(#paint3_linear_950_5895)"
                strokeWidth="0.4"
            />
            <circle
                cx="12.0495"
                cy="63.0493"
                r="2.6164"
                transform="rotate(-0.947326 12.0495 63.0493)"
                fill="url(#paint4_linear_950_5895)"
                stroke="url(#paint5_linear_950_5895)"
                strokeWidth="0.4"
            />
            <defs>
                <linearGradient id="paint0_linear_950_5895" x1="50.9683" y1="46.0682" x2="23.1654" y2="40.1127" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_950_5895" x1="55.3102" y1="35.1998" x2="46.0859" y2="41.0014" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint2_linear_950_5895" x1="31.4487" y1="136.52" x2="35.1708" y2="161.074" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint3_linear_950_5895" x1="20.8499" y1="136.387" x2="25.7362" y2="142.445" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
                <linearGradient id="paint4_linear_950_5895" x1="14.4659" y1="57.7634" x2="18.2434" y2="63.2057" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint5_linear_950_5895" x1="11.7142" y1="59.1149" x2="14.8321" y2="59.2117" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
